import loginController from '@/scripts/libs/login/controller';
import analytic from '../analytic';
import { AnalyticPayload } from '../analytic/types';

export default (): void => {
  // Do you even init?
  loginController.init();

  loginController.getUser().then((user) => {
    if (!user) {
      window.ga('set', 'dimension1', 'Not signed in');
      analytic.send({
        category: 'auth',
        action: 'checked',
        customProperties: {
          ga: false,
        },
      } as AnalyticPayload);
      return;
    };
    /* eslint-disable @typescript-eslint/camelcase */
    // const OneSignal = window.OneSignal || [];
    // OneSignal.push(() => {
    //   OneSignal.sendTags({
    //     user_id: user.id,
    //     supports_points_system: 'true',
    //   });
    // });
    window.snowplow('setUserId', `${user.id}`);

    // Google Analytics
    window.ga('set', 'dimension1', 'Signed in');

    analytic.send({
      category: 'auth',
      action: 'checked',
      customProperties: {
        ga: false,
      },
    } as AnalyticPayload);

    // Intercom
    /*
    const createdDate = new Date(user.stats.createdAt);
    // eslint-disable-next-line @typescript-eslint/camelcase

    window.intercomSettings.user_id = `${user.id}`;
    // eslint-disable-next-line @typescript-eslint/camelcase
    window.intercomSettings.created_at = createdDate.getTime() / 1000;
    */
  });
};
